import { useAppDispatch, useAppSelector } from "../../hooks/redux";
import { setSearchPatientModalOpen } from "../../redux/Layout/layout.slice";

// Simplified search hook for Home Health app
// Search functionality is not used in Home Health (single patient context)
export const useSearchHook = () => {
  const dispatch = useAppDispatch();
  const { searchPatientModalOpen } = useAppSelector((state) => ({
    searchPatientModalOpen: state.layout.searchPatientModalOpen,
  }));

  const onSearchPatientModalOpen = () => {
    dispatch(setSearchPatientModalOpen("global"));
  };

  const onSearchPatientModalClose = () => {
    dispatch(setSearchPatientModalOpen(null));
  };

  return {
    isSearchPatientModalOpen: searchPatientModalOpen,
    onSearchPatientModalOpen,
    onSearchPatientModalClose,
    searchValue: "",
    onChange: () => {},
    response: { data: { data: [] }, isLoading: false },
  };
};
